import {createMessagingService} from "@edu-si/messaging";

import {MESSAGING_SERVICE_TWILIO_ROUTE} from "../../../global-layout/twilio-provider/twilio-service";
import fetchWrapper from "../../../utils/fetchWrapper";

const inAppUrl = "/api/messaging/messages";
const twilioUrl = `/${MESSAGING_SERVICE_TWILIO_ROUTE}`;

// Adapt WISE's authenticated JSON wrapper to the package's Response-like contract.
const fetchInbox = async (url, fetchOptions) => {
  let data;
  try {
    data = await fetchWrapper({url, fetchOptions});
  } catch (error) {
    if (fetchOptions?.signal?.aborted) { throw error; }
    data = url === inAppUrl ? {messages: []} : {hasTwilio: false, inbox: []};
  }
  return {ok: true, json: async () => data};
};

export default createMessagingService({inAppUrl, twilioUrl, fetcher: fetchInbox});
